"use client";

import { Link } from "@/i18n/routing";
import { IconLogin } from "@repo/assets/images";
import { PageTitle } from "@repo/components";
import { useAuth } from "@repo/lib/hooks/account";
import { Button, ErrorMessage, Input, InputPassword, LoadingDots } from "@repo/ui";
import { useTranslations } from "next-intl";
const LoginForm = ({
  variant,
  handleCheckoutSignIn
}) => {
  const {
    handleSocialSubmit,
    handleSubmit,
    handleValidation,
    formErrors,
    isPending,
    isSocialLoginPending
  } = useAuth({
    variant,
    handleCheckoutSignIn
  });
  const tLogin = useTranslations("LoginPage");
  const tCommon = useTranslations("Common");
  return <form onSubmit={handleSubmit} data-sentry-component="LoginForm" data-sentry-source-file="LoginForm.jsx">
      {variant !== "secondary" && <div className="mb-6 text-center">
          <PageTitle title={tLogin("Login_To_Your_Account")} variant="small" />
        </div>}
      <div className="space-y-4">
        <div className="space-y-2">
          <Input id="username" type="text" name="username" placeholder={tCommon("Eg_You_@_Example_com")} label={tCommon("Email")} onChange={handleValidation} data-sentry-element="Input" data-sentry-source-file="LoginForm.jsx" />
          <ErrorMessage message={formErrors?.username} data-sentry-element="ErrorMessage" data-sentry-source-file="LoginForm.jsx" />
        </div>
        <div className="space-y-2">
          <InputPassword name="password" placeholder={tCommon("Password")} label={tCommon("Password")} onChange={handleValidation} data-sentry-element="InputPassword" data-sentry-source-file="LoginForm.jsx" />
          <ErrorMessage message={formErrors?.password} data-sentry-element="ErrorMessage" data-sentry-source-file="LoginForm.jsx" />
        </div>
        <p className="text-right">
          <Link href="/forgot-password" className="text-anchor-text hover:text-anchor-hover text-sm font-medium hover:underline" data-sentry-element="Link" data-sentry-source-file="LoginForm.jsx">
            {tLogin("Forgot_Password")}
          </Link>
        </p>
        <Button type="submit" size="md" className="w-full" variant="primary" disabled={isPending} data-sentry-element="Button" data-sentry-source-file="LoginForm.jsx">
          {isPending ? <LoadingDots className="bg-white" /> : <span className="inline-flex items-center gap-2">
              <IconLogin /> {tCommon("Login")}
            </span>}
        </Button>
      </div>
    </form>;
};
export default LoginForm;